var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _foreignObject;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTornStickyNoteRightSide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 85,
    viewBox: "0 0 159 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6426 2H143.759",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3499 22.6665L15.0753 79.3186",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.593 19.5479V75.4802",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5564 2.6626V10.2132",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.677 2.34814C146.107 2.60927 146.929 6.88479 146.929 8.64028",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5336 80.6853C15.662 79.5677 18.5755 77.9584 19.2919 77.0673C20.7238 75.2865 22.3518 77.5192 23.8272 77.8364C24.3471 77.9481 24.6987 78.6754 25.0378 78.1685C25.3416 77.7142 26.9927 76.4183 27.5674 76.6653C28.859 77.2206 29.4608 79.4072 30.4223 80.4406C30.9054 80.9599 31.5514 81.8424 31.94 82.4331C32.5785 83.4036 32.4766 84.355 33.2771 83.3595C34.1704 82.2485 35.522 81.7997 36.5114 80.8426C37.0125 80.358 38.1184 79.1123 38.7881 79.1123C39.537 79.1123 39.6586 79.9821 40.2517 80.3008C41.1921 80.8062 42.0193 81.4703 42.9981 81.9437C44.0797 82.4669 44.2741 82.8485 45.2025 82.503C46.2322 82.1199 47.0834 81.4575 48.0574 80.9999C48.7529 80.6732 50.528 80.1362 50.9845 79.5842C51.5 78.9609 52.6142 78.0454 53.4238 77.8713C55.5777 77.4083 56.6139 80.3169 58.6095 80.6678C59.2779 80.7854 62.225 81.6683 62.4401 81.3145C63.2035 80.0591 64.9886 78.4926 66.3429 79.6716C67.4353 80.6226 69.4439 80.9228 70.6433 81.7515C70.7965 81.8574 70.9974 81.1651 71.1492 80.9999C71.379 80.7498 71.5857 80.4721 71.7997 80.2134C72.3053 79.602 73.7727 77.8888 74.5461 77.8888C75.9788 77.8888 76.5118 80.1339 77.5094 80.6853C79.5022 81.7868 79.4684 80.8178 80.7437 79.5842C81.8468 78.5171 84.3103 78.4609 85.0621 77.2246C86.0381 75.6196 88.2324 76.6618 89.6877 76.0361C92.1658 74.9708 91.6304 78.3749 91.9824 79.5667C92.6387 81.7887 94.3138 79.7415 95.3794 79.7415C96.9931 79.7415 97.4938 78.2555 98.3968 77.4693C99.2424 76.7332 100.575 74.7078 101.794 74.7078C103.143 74.7078 104.216 75.9662 105.462 75.9662C106.181 75.9662 107.446 76.1061 108.064 76.4381C109.94 77.4463 110.931 76.78 112.617 75.5118C113.391 74.9298 116.369 73.4085 117.08 74.7078C117.601 75.6604 118.125 75.1033 119.031 75.4069C120.23 75.8084 121.118 76.6259 122.211 77.1547C122.799 77.4391 123.997 77.2246 124.633 77.2246C125.519 77.2246 126.362 77.7132 127.253 77.5218C128.419 77.2711 127.964 74.3932 129.529 74.3932C130.357 74.3932 132.639 72.5407 133.342 73.764C133.681 74.3546 135.866 77.7953 137.1 76.8401C138.2 75.9893 140.009 75.337 141.473 75.337C142.415 75.337 143.11 74.8093 144.002 74.7078C144.666 74.6323 144.123 73.764 145.303 73.764",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.65028 11.9424C3.67533 12.1605 5.3129 14.2072 4.70863 14.3371C4.3953 14.4044 1.42255 15.3702 1.69924 15.7525C2.10828 16.3178 2.75752 17.36 3.3926 17.711C3.91323 17.9988 1.5226 20.0397 1.33112 20.5954",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3021 10.6665C26.187 10.6665 25.945 11.024 25.945 11.5243C25.945 12.377 25.7466 13.0182 25.7466 13.8116C25.7466 14.6127 26.58 15.2483 26.6989 16.0037C26.8539 16.9884 26.1686 17.9616 25.996 18.7676C25.8864 19.2794 25.8692 20.0425 25.7409 20.5784C25.6718 20.8669 25.6899 22.2986 25.6899 21.3409",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48553 11.1411H25.5176",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1 21.5571H25.3512",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.479 10.3716C133.426 10.3716 133.571 11.1737 134.396 11.4016C135.247 11.6369 135.772 12.4712 136.419 12.9581C137.034 13.4212 137.813 13.6843 136.525 13.8622C135.449 14.011 134.598 14.4961 133.65 14.9037C132.961 15.2001 133.994 15.5435 134.609 15.888C135.021 16.1186 135.88 16.7085 136.312 16.7578C137.664 16.9116 136.365 17.5536 135.839 17.742C135.108 18.0041 134.481 18.5845 133.757 18.8178",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M157.185 9.75342C156.511 10.4057 155.383 11.5668 156.759 12.2713C157.526 12.6643 158.655 13.1009 157.516 13.9193C156.942 14.3322 156.324 14.7411 155.694 15.0638C155.117 15.3594 155.885 15.8429 156.073 16.1396C156.526 16.8576 157.452 17.0675 157.824 17.7877",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.249 17.7876H157.824",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.119 9.95947H156.119",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _foreignObject || (_foreignObject = /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 160,
    height: 85
  }, /*#__PURE__*/React.createElement("p", {
    id: "torn-sticky-note-right-side",
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "\r\n            I have this page so it is easy and quick to contact me\r\n        "))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTornStickyNoteRightSide);
export default __webpack_public_path__ + "static/media/torn-sticky-note-right-side.9480e275aed26ed279b2f940dfa10362.svg";
export { ForwardRef as ReactComponent };